module.exports = __webpack_public_path__ + "static/img/bg_fail.94fdb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/bg_fail.png
// module id = /iLf
// module chunks = 1